import script from "./DynamicCardFace.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicCardFace.vue?vue&type=script&setup=true&lang=js"

import "./DynamicCardFace.vue?vue&type=style&index=0&id=7bc63173&lang=css"
import "./DynamicCardFace.vue?vue&type=style&index=1&id=7bc63173&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bc63173"]])

export default __exports__